import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import {
    BINDING_CARD_PENDING,
    BINDING_CARD_SUCCESS,
    BINDING_CARD_FAILED,
} from 'constants/customer';
import { Translate } from 'react-redux-i18n';

const CardBindingStatus = ({ status }) => {
    let el;
    const colorMap = {
        [BINDING_CARD_SUCCESS]: 'success',
        [BINDING_CARD_PENDING]: 'warning',
        [BINDING_CARD_FAILED]: 'danger',
    };

    switch (status) {
    case BINDING_CARD_SUCCESS:
    case BINDING_CARD_PENDING:
    case BINDING_CARD_FAILED:
        el = (
            <Badge color={ colorMap[status] }>
                <Translate value={ `customer.binding_card_status_${ status }` } />
            </Badge>
        );
        break;
    default:
        el = (
            <Badge color="secondary">
                <Translate value="unknown" />
            </Badge>
        );
        break;
    }

    return (
        <div className="control-group view-mode">
            <Translate className="caption" value="customer.binding_card_status" tag="h5" />
            <div className="control-wrapper">
                <span className="view-control">{ el }</span>
            </div>
        </div>
    );
};

CardBindingStatus.propTypes = {
    status: PropTypes.number,
};
CardBindingStatus.defaultProps = {
    status: undefined,
};

export default CardBindingStatus;
